import React from 'react';

export default class NoAppointments extends React.Component {
  render() {
    return <div>You do not have any upcoming appointments.</div>;
  }
}
